import { onEvent } from "./_dom";

export function init(context, selector = ".js-show-target") {
	onEvent(context, selector, "click", event => {
		event.preventDefault();
		const target = document.querySelector(event.target.getAttribute("href"));
		target.style.display = target.style.display === "revert" ? "" : "revert";
	});
}